//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-useless-escape */
import { mapGetters } from 'vuex'
import PromoTerms from '~/components/promos/Holiday2021PromoTerms.vue'
import PromoCrisisBanner from '~/components/promos/Holiday2021CrisisBanner.vue'
import pageMetadata from '~~/.cache/page-metadata.json'

function escapePathRegexp(string) {
  return string.replace(/[|\\{}()[\]^+?]/g, '\\$&').replace(/-/g, '\\x2d')
}

export default {
  components: {
    PromoTerms,
    PromoCrisisBanner
  },

  data() {
    return {
      showWriteReview: false
    }
  },

  computed: {
    ...mapGetters('user', ['customerId', 'isGuest', 'isSubscriber']),

    productId() {
      return Number(this.$route.params.id) || null
    }
  },

  watch: {
    $route() {
      if (document.activeElement) {
        document.activeElement.blur()
      }
    }
  },

  mounted() {
    this.initModalQuery()
  },

  methods: {
    initModalQuery() {
      this.showWriteReview =
        this.$route.query.show === 'write-review' ||
        this.$route.hash === '#review'
    }
  },

  head() {
    const metadata = pageMetadata.find(data => {
      const pathRegex = new RegExp(escapePathRegexp(data.pagePath) + '$')
      return pathRegex.test(this.$route.path)
    })

    const head = {
      bodyAttrs: {
        class: [`page-${this.$route.name}`]
      },
      title: metadata?.pageTitle,
      // Filters out all non-metadata and maps remaining to hid objects
      meta: metadata?.metaDescription
        ? [
            {
              hid: 'description',
              name: 'description',
              href: metadata.metaDescription
            },
            {
              hid: 'og:description',
              name: 'og:description',
              href: metadata.metaDescription
            }
          ]
        : [],
      link: metadata?.pagePath
        ? [{ hid: 'canonical', rel: 'canonical', href: metadata.pagePath }]
        : [],
      script: [
        this.customerId
          ? {
              innerHTML: `amplitude.getInstance().setUserId(${this.customerId})`
            }
          : {},
        {
          innerHTML: `
            function getGaCustomerId() {
              let match = document.cookie.match('(?:^|;)\\s*_ga=([^;]*)')
              const raw = match ? decodeURIComponent(match[1]) : null
              if (raw) {
                match = raw.match(/(\d+\.\d+)$/)
              }
              const gacid = match ? match[1] : null
              if (gacid) {
                return gacid
              }
            }

            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              customerStatus: '${
                this.isSubscriber ? 'Customer' : 'Non-Customer'
              }',
              userID: ${this.customerId} || getGaCustomerId(),
              ${
                this.customerId
                  ? `segment: '${this.$store.state.user.details.segment}'`
                  : ''
              }

            })
          `
        }
      ],
      __dangerouslyDisableSanitizers: ['script']
    }

    return head
  }
}
